/* eslint-disable no-nested-ternary */
import React from 'react';
import dayjs from 'dayjs';
import 'dayjs/locale/es';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { Line } from 'react-chartjs-2';

dayjs.locale('es');

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

interface SellsLineChartProps {
  data: JSON[];
  timeScale: string;
  label?: string;
}

function LineChart({ data, timeScale, label }: SellsLineChartProps) {
  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: 'bottom' as const,
      },
    },
  };

  // JSON[] KEY is label and VALUE is data
  const dataChart = {
    // for each json get key
    labels: data?.map((info) =>
      Object.keys(info).map((key) =>
        dayjs(key).format(
          timeScale === 'hour'
            ? 'dddd DD, hh:mm a'
            : timeScale === 'day'
            ? 'DD-MM-YYYY'
            : timeScale === 'month'
            ? 'MMMM'
            : 'YYYY'
        )
      )
    ),
    datasets: [
      {
        label: label ?? 'Ventas ($)',
        data: data.map((info) => Object.values(info)[0]),
        borderColor: '#AE5DCC',
        backgroundColor: '#AE5DCC',
        fill: true,
      },
    ],
  };

  return (
    <div className="w-full h-full">
      <Line options={options} data={dataChart} />
    </div>
  );
}

export default LineChart;
